var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearningStrategistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 33,
    viewBox: "0 0 42 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7817 6.62877L4.89006 25.3156C2.77184 28.6442 5.16292 33 9.10837 33H32.8916C36.8371 33 39.2282 28.6443 37.1099 25.3156L25.2183 6.62877C23.2535 3.54127 18.7465 3.54127 16.7817 6.62877Z",
    fill: "#FFAD4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3161 12.094V18.386C22.3161 19.0533 22.2831 19.7097 22.2171 20.355C22.1511 20.993 22.0631 21.6713 21.9531 22.39H20.1161C20.0061 21.6713 19.9181 20.993 19.8521 20.355C19.7861 19.7097 19.7531 19.0533 19.7531 18.386V12.094H22.3161ZM19.3351 26.504C19.3351 26.2767 19.3755 26.0603 19.4561 25.855C19.5441 25.6497 19.6615 25.4737 19.8081 25.327C19.9621 25.1803 20.1418 25.063 20.3471 24.975C20.5525 24.887 20.7725 24.843 21.0071 24.843C21.2345 24.843 21.4508 24.887 21.6561 24.975C21.8615 25.063 22.0375 25.1803 22.1841 25.327C22.3308 25.4737 22.4481 25.6497 22.5361 25.855C22.6241 26.0603 22.6681 26.2767 22.6681 26.504C22.6681 26.7387 22.6241 26.9587 22.5361 27.164C22.4481 27.362 22.3308 27.5343 22.1841 27.681C22.0375 27.8277 21.8615 27.9413 21.6561 28.022C21.4508 28.11 21.2345 28.154 21.0071 28.154C20.7725 28.154 20.5525 28.11 20.3471 28.022C20.1418 27.9413 19.9621 27.8277 19.8081 27.681C19.6615 27.5343 19.5441 27.362 19.4561 27.164C19.3755 26.9587 19.3351 26.7387 19.3351 26.504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningStrategistIcon);
export default __webpack_public_path__ + "static/media/LearningStrategistIcon.724f13900675598aec1aea1aa2514575.svg";
export { ForwardRef as ReactComponent };